import styled from "styled-components";


export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    width: 100%;
    border-radius: 5px;
    // height: 33px;
    border: none;
    box-shadow: none;
    user-select: none;
    outline: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -webkit-tap-highlight-color: transparent;
    padding: 5px;
    background: transparent;
    margin-block: 2.5px;
    gap: 10px;
`;


export const ColumnContainer = styled.div`
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 5px;
    min-height: 33px;
`;

export const StateIndicator = styled.img`
    width: 16px;
    height: 16px;
`;

export const VarIndicator = styled.span`
    color: #4361EE;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
`;

export const NameContainer = styled.div`
    white-space: nowrap;
    width: ${props=>props.maxwidth ? '75px' : '85px'};
    color: #333;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    overflow: auto;
    &::-webkit-scrollbar {
        height : 3px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: #ccc;
        border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background-color: #aaa
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-button {
        display: none;
    }
    @media (min-width: 720px) {
        width: 160px;
    }
`;

export const ValueContainer = styled.div`
    white-space: nowrap;
    color: #4361EE;
    width: 70px; 
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
`;

export const ValueUnit = styled.span`
    white-space: nowrap;
    width: 30px;
    color: #4361EE;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
`

export const RefIndicator = styled.span`
    min-width: 20px;
    width: 20px;
    color: #333;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
`;

export const RefContainer = styled.div`
    white-space: nowrap;
    width: 25px;
    color: #333;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    overflow: auto;
    &::-webkit-scrollbar {
        height : 3px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: #ccc;
        border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background-color: #aaa
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-button {
        display: none;
    }
`;

export const RefUnit = styled.span`
    white-space: nowrap;
    width: 35px;
    color: #333;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
`;